/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header-col[_ngcontent-%COMP%]{display:flex;cursor:pointer}.header-col--sorted[_ngcontent-%COMP%]{font-weight:500;color:#293348}.header-sorticons[_ngcontent-%COMP%]{display:flex;padding-top:2px;padding-left:10px}.header-sorticons[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
